import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
//Componentes Material
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
    paper: {
        padding: theme.spacing(2),
        marginTop: theme.spacing(2)
    }
});

function VitalizePaper({ classes, className, children }) {
    return (
        <Paper className={clsx(classes.paper, className)}>
            {children}
        </Paper>
    );
}

VitalizePaper.propTypes = {
    classes: PropTypes.shape({
        paper: PropTypes.string
    }),
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
    children: PropTypes.any
};

export default withStyles(styles)(VitalizePaper);